// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  structureStateId: __t.string().primaryKey().name("structure_state_id"),
  matchId: __t.string().name("match_id"),
  structureIndex: __t.u32().name("structure_index"),
  hp: __t.f64(),
  gateOpen: __t.bool().name("gate_open"),
  structureType: __t.option(__t.string()).name("structure_type"),
  material: __t.option(__t.string()),
  x: __t.option(__t.f64()),
  y: __t.option(__t.f64()),
  width: __t.option(__t.f64()),
  height: __t.option(__t.f64()),
  radius: __t.option(__t.f64()),
  ownerTeam: __t.option(__t.u32()).name("owner_team"),
  maxHp: __t.f64().name("max_hp"),
  builtInMatch: __t.bool().name("built_in_match"),
  builtByArmy: __t.option(__t.u32()).name("built_by_army"),
  builtTick: __t.option(__t.u32()).name("built_tick"),
  facing: __t.option(__t.f64()),
});
